import { Md5 } from 'ts-md5/dist/md5';

export class ResetPassword {
	private password!: string;
	token!: string;
	
	set md5password(pass: string) {
		this.password = Md5.hashStr(pass).toString();
	}

}

// Maiuscola, Minuscola, Carattere Speciale, Numero, Lunghezza minima 8 caratteri
// eslint-disable-next-line no-useless-escape
export const PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;